import { ErrorResponse } from '~shared/models';
import { LocalFilters } from '../../models';

export interface LocalFiltersState {
  payload: LocalFilters;
  saving: boolean;
  error: ErrorResponse;
}

export const localFiltersInitialState: LocalFiltersState = {
  payload: {
    categories: [],
    attributes: [],
  },
  saving: false,
  error: null
};

